import React, { createContext, useContext, useState } from 'react';
import { japanese } from '../languages/japanese';
import { english } from '../languages/english';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('japanese');
  
  const texts = currentLanguage === 'japanese' ? japanese : english;
  
  const switchLanguage = (language) => {
    setCurrentLanguage(language);
  };

  const value = {
    currentLanguage,
    texts,
    switchLanguage,
    isJapanese: currentLanguage === 'japanese',
    isEnglish: currentLanguage === 'english'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 